<template>
    <div class="coffee-index-home">
        <coffee-search-bar
                :filter-params="filterParams"
                :include-price-sort="true"
                :preset-filter-params="presetFilterParams"
                @queryParamsUpdated="searchParamsUpdated"
                ref="searchBar"
        />

        <div :class="{'top-padded': anyFilterPillsDisplayed}">
            <transition name="fade-fast" mode="out-in">
                <div v-if="loading" class="spinner-wrapper" key="loading">
                    <loading-spinner />
                </div>

                <div v-else>
                    <div v-if="searchingResult">
                        <div v-if="specificCategories.length > 0 || coffeeSearchResults.length > 0">
                            <div v-if="(filters != undefined && filters['brew_methods'].length === 1) && (filters['brew_methods'].includes('espresso') || filters['brew_methods'].includes('cold_brew'))">
                                <coffee-espresso-list
                                    :categories="specificCategories"
                                    :playlist-data="playlistData"
                                    :brewlist-detail="brewlistDetails"
                                    :buy-now-props="buyNowProps"
                                    v-on:add-coffee-to-playlist="addCoffeeToPlaylist"
                                />
                            </div>
                            <div v-else>
                                <coffee-card-list
                                    :paramfilter=this.filters
                                    :coffees="coffeeSearchResults"
                                    :playlist-data="playlistData"
                                    :brewlist-details="brewlistDetails"
                                    :select5lb="select5lb"
                                    :buy-now-props="buyNowProps"
                                    v-on:add-coffee-to-playlist="addCoffeeToPlaylist"
                                />
                                <infinite-loading v-if="this.page !== 1" @infinite="loadMoreResults" spinner="circles">
                                    <span slot="no-more"></span>
                                    <span slot="no-results"></span>
                                </infinite-loading>
                            </div>
                        </div>
                        <div v-else class="noResultMessage centered">
                            <strong>Sorry, we couldn't find any coffees matching.</strong>
                        </div>
                    </div>
                    <coffee-category-list v-else
                                          v-show="!promo5lb"
                                          :categories="coffeeCategories"
                                          :playlist-data="playlistData"
                                          :brewlist-detail="brewlistDetails"
                                          :buy-now-props="buyNowProps"
                                          v-on:add-coffee-to-playlist="addCoffeeToPlaylist"
                    />
                </div>
            </transition>
        </div>
    </div>

</template>

<script>
    import CoffeeCardList from "./coffee-card-list-home";
    import CoffeeEspressoList from"./coffee-espresso-list-home";
    import CoffeeCategoryList from "./coffee-category-list-home"
    import CoffeeSearchBar from "../common/coffee-search-bar";
    import CoffeeMixin from "../../mixins/coffee-mixin";
    import LoadingSpinner from "../common/loading-spinner";
    import InfiniteLoading from 'vue-infinite-loading';
    // images
    import 'home/three-bags.png';
    import 'home/5lb-bag.png';
    import 'home/coffee-flight.png';

    export default {
        components: {
            CoffeeCardList,
            CoffeeEspressoList,
            CoffeeCategoryList,
            CoffeeSearchBar,
            LoadingSpinner,
            InfiniteLoading
        },
        mixins: [
            CoffeeMixin
        ],
        props: {
            coffees: Array,
            filterParams: Object,
            coffeeCategories: Array,
            promo5lb: Boolean,
            buyNowProps: Object,
            brewlistDetails: Object
        },
        data: function () {
            return {
                playlistData: undefined,
                coffeeSearchResults: undefined,
                searchParams: undefined,
                numCoffeesPerLoad: 27,
                page: 1,
                loading: false,
                select5lb: false,
                presetFilterParams: [],
                filters: undefined,
                specificCategories: [],
                searchingResult: false
            }
        },
        methods: {
            searchParamsUpdated(searchParams) {
                this.page = 1;

                if (searchParams['search'] || searchParams['filter'] || searchParams['sort'] ) {
                    this.searchingResult = true;
                    this.filters = searchParams['filter'];
                    if ((this.filters !== undefined && this.filters.brew_methods.length === 1) && (this.filters.brew_methods.includes("espresso") || this.filters.brew_methods.includes("cold_brew") )){
                        this.searchParams = searchParams;
                        this.searchForSpecificKeyword();
                    }else{
                        this.searchParams = searchParams;
                        this.updateSearchResults();
                    }
                } else {
                    if (this.presetFilterParams.includes('5lb')) {
                        return window.location.replace('/coffees');
                    }
                    this.searchingResult = false;
                    this.specificCategories = [];
                    this.coffeeSearchResults = undefined;
                }
                this.scrollToTop();
            },
            updateSearchResults() {
                this.loading = true;

                this.$api.get('/v1/coffees', this.getQueryParams())
                    .then( res => {
                        this.coffeeSearchResults = res.data;
                        this.loading = false;
                        if (!res.data || res.length === 0) {
                            $state.complete();
                        }
                    })
                    .catch( err => {
                            console.error(err);
                            this.loading = false;
                        }
                    );
                this.page++;
            },
            searchForSpecificKeyword(){
                this.loading = true;
                this.specificCategories = [];
                this.$api.get('/v1/coffees/espresso_only', this.getQueryParams())
                    .then( res => {
                        this.specificCategories = res.data.map(r=> r.coffee_detail);
                        this.loading = false;
                        if (!res.data || res.length === 0) {
                            $state.complete();
                        }
                    })
                    .catch( err => {
                            console.error(err);
                            this.loading = false;
                        }
                    );
            },
            getQueryParams() {
                return {
                    params: {
                        page: this.page,
                        per: this.numCoffeesPerLoad,
                        includePrice: this.isAdmin,
                        ...this.searchParams
                    }
                };
            },
            loadMoreResults($state) {
                this.$api.get('/v1/coffees', this.getQueryParams())
                    .then( res => {
                        if (res.data.length < this.numCoffeesPerLoad) {
                            $state.complete();
                        } else {
                            $state.loaded();
                        }
                        this.coffeeSearchResults.push(...res.data);
                    })
                    .catch(console.error);
                this.page++;
            },
            addCoffeeToPlaylist(coffeeId, size, grind) {
                // TODO: Implement this method in order to decouple vue components from add.js
                // if (!this.playlistData) {
                //     console.error('Error: playlistData is not defined.');
                //     return;
                // }
                //
                // const newItem = {
                //     item_id: coffeeId,
                //     item_type: 'product',
                //     size: size,
                //     grind: grind,
                // };
                //
                // this.playlistData.items.push(newItem);
                // // Save it in cookie
                // if ( getUserId() == null ) {
                //     Cookies.set('blids', this.getProductIds(data));
                //     Cookies.set('frq', data.frequency);
                // }
                //
                // this.$api.patch('v1/users/me/brewlist', this.playlistData)
                //     .then(res => {
                //         this.playlistData = res.data;
                //         if (this.playlist.force_process_next_batch)
                //         this.fetchProducts();
                //         this.$emit('refresh-suggestions');
                //     })
                //     .catch((err) => console.error(err)) // TODO: Toggle back if error
            },
            scrollToTop() {
                this.$refs.searchBar.scrollToTop();
            },
            searchFor5lb() {
                this.presetFilterParams = ['5lb'];
                this.select5lb = true;
            },
            facebookAds(){
                fbq('track', 'ViewContent');
            }
        },
        computed: {
            anyFilterPillsDisplayed: function() {
                if (!this.searchParams || !this.searchParams.filter) {
                    return false;
                }
                for (let key of Object.keys(this.searchParams.filter)) {
                    if (this.searchParams.filter[key].length) {
                        return true;
                    }
                }
                return false;
            },
        },
        mounted() {
            this.$api.get('v1/users/me/brewlist')
                .then( (res) => this.playlistData = res.data)
                .catch(console.error);

            if (this.promo5lb) {
                this.searchFor5lb();
            }
            this.facebookAds();
        }
    }
</script>

<style lang="scss" scoped>
    @import "./../../styles/variables_home";

    .coffee-index-home {
        margin-top: 2rem;
        padding-bottom: 4rem;
    }
    .top-padded {
        padding-top: 1.5rem;
    }
    .noResultMessage {
        margin-top: 30vh;
        text-align: center;
    }
    .spinner-wrapper {
        min-height: 50vh;
        display: flex;
        align-items: center;
    }

    @media only screen and (max-width: $min-desktop-sm-width) {
        .top-button-wrapper {
            flex-direction: column;
            margin: 0 0 2rem 0;
        }
        .btn-with-img {
            width: auto;
            margin: 1.5rem 10vw;
        }
    }

    @media only screen and (max-width: $max-tablet-width) {
        .coffee-index-home {
            padding-top: 0;
        }
        .top-padded {
            padding-top: 4rem;
        }
    }
</style>

<!-- HACK: Styles for the child components are overwritten in this hacky way. -->
<style lang="scss">
    @import "../../styles/common_home";
    @import "./../../styles/variables_home";

    * {
        font-family: "futura-pt"!important;
    }
    a {
        text-decoration: none!important;
    }
    /* Search bar */
    .coffee-search-wrapper {
        background-color: $color-primary!important;
    }
    .coffee-search-input {
        background-color: $color-primary!important;
    }
    .coffee-search-bar {
        background-color: $white!important;
    }
    .sort-main-btn {
        background-color: $yellow!important;
        &:hover {
            background-color: darken($yellow, 5%)!important;
        }
    }
    .sort-item {
        background-color: $yellow-light!important;
        &:hover {
            background-color: darken($yellow-light, 5%)!important;
        }
    }
    .sort-pill {
        color: $white!important;
        background-color: $yellow!important;
        border-color: $yellow!important;
        &:hover {
            background-color: lighten($yellow, 10%)!important;
        }
    }
    .sort-clear-pill {
        color: $yellow!important;
        background-color: $white!important;
        border-color: $yellow!important;
        &:hover {
            color: darken($yellow, 20%)!important;
            border-color: darken($yellow, 20%)!important;
        }
    }
    .active-sort-item {
        background-color: darken($yellow-light, 15%)!important;
    }
    .filter-main-btn {
        background-color: $green!important;
        &:hover {
            background-color: darken($green, 5%)!important;
        }
    }
    .category-btn {
        background-color: $green-light!important;
        &:hover {
            background-color: darken($green-light, 5%)!important;
        }
    }
    .param-btn {
        color: darken($green, 10%)!important;
        border: solid 1px $green!important;
        &:hover {
            color: darken($green, 30%)!important;
            border-color: darken($green, 20%)!important;
        }
    }
    .active-param-btn {
        color: white!important;
        background-color: $green!important;
    }
    .added-param-pill {
        background-color: $green!important;
        &:hover {
            background-color: lighten($green, 10%)!important;
        }
    }
    .clear-pill {
        background-color: $white!important;
        color: $green!important;
        border: 1px solid $green!important;
        &:hover {
            color: darken($green, 20%)!important;
            border-color: darken($green, 20%)!important;
        }
    }

    @media only screen and (max-width: $max-tablet-width) {
        .mobile-break {
            display: block;
            content: "";
            margin-top: -4px;
        }
        .hide-on-mobile {
            display: none;
        }
    }
</style>
